import { baseApi } from '@/api/rtk/baseApi';

export const userApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUser: builder.query({
      query: ({ userId }) => ({
        url: '/get-user/',
        method: 'POST',
        body: { user_id: userId },
      }),
      transformResponse: (response) => response?.user ?? null,
      providesTags: ['User'],
    }),
  }),
});

export const { useGetUserQuery } = userApi;
